export const KEY_ESC = 27;
export const KEY_ENTER = 13;
export const KEY_CHAT = 13;
export const KEY_FIREFOOD = 119; // 'w'
export const KEY_SPLIT = 32; // space
export const KEY_LEFT = 37;
export const KEY_UP = 38;
export const KEY_RIGHT = 39;
export const KEY_DOWN = 40;

export const PLAYER_CONFIG = {
    border: 6,
    textColor: '#FFFFFF',
    textBorder: '#000000',
    textBorderSize: 3,
    defaultSize: 30
};

export const DEFAULT_SETTINGS = {
    borderDraw: true,
    toggleMassState: 0,
    backgroundColor: '#FFFFFF',
    lineColor: '#CCCCCC',
    continuity: false,
    roundFood: true
};


